import styled from 'styled-components';

export const Wrapper = styled.div`
  a {
    font-weight: 500;
    text-decoration: underline;
  }
`;
